'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createHashHistory');
module.exports = require('./index.js').createHashHistory;



//////////////////
// WEBPACK FOOTER
// ./~/history/createHashHistory.js
// module id = 1288
// module chunks = 4